// Outbound links built from lead/contact fields. The scheme-prefix dance was
// copy-pasted across the drawer, the pipeline card, the command center and the
// leads table, so it lives here now.

// Users type "acme.com" far more often than "https://acme.com", and a bare
// domain in href makes the browser resolve it relative to the current page.
// Tests for a real scheme rather than a "http" prefix, so a domain that merely
// starts with those letters (httpbin.org) still gets prefixed correctly.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

export function websiteHref(website) {
  const raw = String(website || '').trim();
  if (!raw) return null;
  return HAS_SCHEME.test(raw) ? raw : `https://${raw}`;
}

export function mailtoHref(email) {
  const raw = String(email || '').trim();
  return raw ? `mailto:${raw}` : null;
}
